<template>
  <div id="course" class="app-inner">
     <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="$util.reback('/certiFicate')">
            返回
            </div>
            </div>
       <div class="public-btn-div flex align-cen">
      <div class="public-add"  @click="openBl">
        新增证书领取人
      </div>
    </div>
      <div class="p-tit-c">
        <div class="businessList-filter">
                <div class="businessList-filter-list flex align-cen">
            <div class="fl-le flex align-cen">
          <div class="label">学员姓名：</div>
          <div class="el-select1">
            <el-input placeholder="请输入学员姓名" v-model="search" clearable> </el-input>
          </div>
         </div>
             <div class="fl-rt flex align-cen">
          <div class="label">学员电话：</div>
          <div class="el-select1">
          <el-input placeholder="请输入学员电话" v-model="search1" clearable> </el-input>
          </div>
         </div>
          <div class="fl-rt flex align-cen">
          <div class="label">学员身份证：</div>
          <div class="el-select1">
          <el-input placeholder="请输入学员身份证" v-model="search2" clearable> </el-input>
          </div>
         </div>
      </div>
       <div class="businessList-filter-list flex align-cen">
        <div class="label">证书发放日期：</div>
        <el-date-picker
          v-model="value2"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions2"
          @change="classSelect"
        >
        </el-date-picker>
      </div>
                 <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="classSelect">
        搜索
        </div>
         <div class="public-btn-small-plan" @click="exportExcel(multipleSelection)">
          {{uoloadText}}
        </div>
        <div class="public-btn-small-text" @click="reset">
        重置筛选条件 
        </div>
      </div>
        </div>
      </div>
                <div class="businessList-container">
        <div class="businessList-container-table">
             <el-table
             ref="multipleTable"
            :data="list"
            border
            style="width: 100%"
            :key="99902"
            :row-key="getRowKeyOfTarget"
          @selection-change="handleSelectionChange"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
             <el-table-column type="selection" width="55" reserve-selection align="center" fixed="left"> </el-table-column>
            <el-table-column
            prop="recipientName"
            label="姓名"
           align="center"
             >
            </el-table-column>
            <el-table-column
            prop="phone"
            label="电话"
           align="center"
            >
            </el-table-column>
           <el-table-column
            prop="idNo"
            label="身份证号"
           align="center"
            >
            </el-table-column>
        <el-table-column label="学员照片" align="center" prop="pic">
            <template slot-scope="scope" >
                <img :src="scope.row.pic" alt="" style="display: block;width:30%;margin:0 auto" @click="openMobile(scope.row)">
            </template>
         </el-table-column>
          <el-table-column label="证书发放日期" align="center" prop="issueTime">
         </el-table-column>
            <el-table-column
            label="操作"
            align="center"
            >
              <template slot-scope="scope">
                <div>
                    <el-button type="text" size="small" @click="uploadCert(scope.row)" :loading="certLoading">下载证书</el-button>
                <el-button type="text" size="small"  class="daner" style="color:red" @click="deletSt(scope.row)">取消关联</el-button>
                </div>
              </template>
            </el-table-column>
        </el-table>
         <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
        </div>
      </div>
           <el-dialog
          title="新增证书关联人"
          :visible.sync="centerDialogVisible"
          width="80%"
          :append-to-body="true"
          v-if="centerDialogVisible"
          center>
            <div class="forminfo"> 
                <stTemplate 
                :selectType='centerDialogVisible'
                @sendStatus1="classSelectTem"
                ref="appTemplate"
                ></stTemplate>
                <div class="authbtn flex align-cen">
                        <el-button plain @click="reback1(0)">取消</el-button>
                        <el-button type="primary" class="mft" @click="onSubmit1">确认选择</el-button>
                    </div>
            </div>
           </el-dialog>
            <certTemplate ref="certTemplate" 
            :propId='propId' 
            :arrType="arrType"
             @sendStatus2="closeTem" 
             v-if="centerDialogVisible1">
             </certTemplate>
               <!-- <el-dialog
          title="下载证书"
          :visible.sync="centerDialogVisible1"
          width="100%"
          :append-to-body="true"
          v-if="centerDialogVisible1"
          center>
           
               </el-dialog> -->
        
  </div>
</template>
<script>
import {getcertReceive1,addcertReip,getReceive} from "@/api/index/index"  //证书学员分页、领取证书分页、删除证书、新增领取人
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
import stTemplate from "@/views/Course/certiFicate/certiFicateStInfo/index.vue"; //将学员列表页面作为组件使用
import certTemplate from "@/webenterprise/enCert/index.vue"; //将证书页面作为组件使用
export default {
    components:{
      paginaTion,
      stTemplate,
      certTemplate
    },
  data () {
    return {
      uoloadText:'批量下载证书',
      arrType:'',
      multipleSelection:[],
      certLoading:false,
      centerDialogVisible1:false,
      selectList:[],
      relationList:[],
      centerDialogVisible:false,
      search:'',
      search1:'',
      search2:'',
      list:[],
      currentPage: 1, //初始页
      PageSize: 10, //每页的数据
      totalCount: 0,
      list1:[],
      currentPage1: 1, //初始页
      PageSize1: 10, //每页的数据
      totalCount1: 0,
      start_time:'',
      end_time:'',
      value2:'',
         pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
             },
    }
  },
  activated(){
        this.getList()
    },
  created () {
  },
  methods: {
       getRowKeyOfTarget(row) {
            return row.id
            },
            // 表格选择
         handleSelectionChange(val) {
        this.multipleSelection = val;
      },
        emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.getList()
      },
    // 获取证书学院列表
    getList(){
      let params = {
        name:this.search,
        certificateId:this.$route.query.id,
        idNo:this.search2,
        phone:this.search1,
        issueTimeStart:this.start_time,
        issueTimeEnd:this.end_time,

        current: this.currentPage,
        size:this.PageSize,
      }
      getcertReceive1(params)
      .then(res =>{
          this.list = res.data.records
          this.totalCount = res.data.total;
          this.relationList = res.data.records
      })
    },
    // 搜索
    classSelect(){
      if(this.value2){
             this.start_time = this.value2[0]
            this.end_time = this.value2[1]
            }else{
              this.start_time = ""
              this.end_time = ""
            }
          this.currentPage = 1
          this.getList()
    },
    // 重置
    reset(){
       this.search=""
          this.search1=""
           this.search2=""
           this.value2 = ""
            this.start_time = ""
              this.end_time = ""
          this.currentPage=1
          this.getList()
    },
    // 关闭证书
    closeTem(val){
        this.propId = ''
        this.centerDialogVisible1 = false
        this.certLoading = false
    },
    openMobile(data){
       const newurl = this.$router.resolve({name: 'mobileIndex', query: {id: data.id}})
        window.open(newurl.href,'_blank')
    },
         // 批量下载
      exportExcel(val){
        if(val.length !=0){
          for(let  i=0;i<val.length;i++){
             setTimeout(() => {
                this.uploadCert(val[i])
                this.arrType = 'moreUpload'
                },i * 3000)
          }

        }else{
           this.$util.Notifi('请选择下载证书','error','fa-exclamation-circle')
        }
      },
    // 下载证书
    uploadCert(data){
      // console.log(data)
      this.arrType = ""
        this.propId = data.id
        this.centerDialogVisible1 = true
        this.certLoading = true
        //  const newurl = this.$router.resolve({name: 'enCert', query: {id: data.id}})
        // window.open(newurl.href,'_blank')
    },
    // 新增领取人
    openBl(){
         this.centerDialogVisible = true  
            this.$nextTick(function () {   
                 this.$refs.appTemplate.editfun(this.relationList)    
             })
    },
       // 表格选择
        classSelectTem(val,val1){
           this.selectList = val
        },
       // 取消选择
        reback1(){
            this.$refs.appTemplate.remove()  
             this.centerDialogVisible = false  
        },
               // 确认选择
        onSubmit1(){
           this.relationList = this.selectList
           let arr = this.relationList.map(item => item.id);
           let params = {
            certificateId:this.$route.query.id,
            recipientIds:arr
           }
           addcertReip(params)
           .then(res =>{
            if(res.code == 0){
                this.centerDialogVisible = false
                this.currentPage = 1
                this.getList()
            }else{
                this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
            }
           })
           
        },
    // 删除学员
    deletSt(data){
       this.$confirm('确定要取消关联该学员？取消关联后，该学员的证书将不展示。', '温馨提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
              }).then(() => {
                  getReceive({id:data.id},'DELETE')
                  .then(res =>{
                    if(res.code == 0){
                      this.$util.Notifi('取消成功','success','fa-check')
                   this.getList()
                    }else{
                      this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                    }
                  })
              }).catch(() => {          
              });
    },
    // 打开领取证书窗口
    // openReceive(data){
    //   this.centerDialogVisible = true
    //   this.getList1(data.id)
    // },
  },
}
</script>
<style lang="scss" scoped>
</style>